export const TaskID = 1;
export const ProjID = 2;
//# sourceMappingURL=constants.js.map